import { CarrierDisplayName } from '../../../constants/carrierTypes';
import { HANDLING_FEE_LINE, HANDLING_FEE_ORDER } from '../../../constants/operators';

export function getRevenueDescription(formula) {
  if (formula?.includes('retail_price')) {
    const percentageRegex = /^retail_price\*(\d+)\/100$/;
    const parts = formula.match(percentageRegex);
    if (parts) {
      return `Revenue share based on retail price: ${100 - parts[1]}%`;
    }
  }

  return 'Prices are based on agreed wholesale prices';
}

export function getHandlingFeeDescription(handlingFee) {
  if (!handlingFee) {
    return <span>No handling fee</span>;
  }

  switch (handlingFee.type) {
    case HANDLING_FEE_ORDER:
      return (
        <span>
          <strong>Handling fee per order:</strong> {handlingFee.formula}
        </span>
      );

    case HANDLING_FEE_LINE:
      return (
        <span>
          <strong>Handling fee per order line:</strong> {handlingFee.formula}
        </span>
      );

    default:
      return '';
  }
}

export function getRefundCostDescription(refundCost) {
  return refundCost ? (
    <span>
      <strong>Refund fee:</strong> {refundCost}
    </span>
  ) : (
    <strong>No refund fee</strong>
  );
}

export function getPaymentMethod(billingMethod) {
  if (!billingMethod) {
    return '';
  }
  const method = billingMethod === 'none' ? 'Based On Invoice' : 'Credit Card / Bank Transfer';
  return (
    <span>
      <strong>Payment method:</strong> {method}
    </span>
  );
}

export function getShippingCostDescription(shipperAccountType, shipperAccount, shippingCost) {
  const shippingCostTerms = [];

  if (shipperAccountType) {
    const type = CarrierDisplayName[shipperAccountType] || 'None';
    shippingCostTerms.push(
      <li key="shipperAccount">
        Using Shipper Account: {shipperAccount} ({type})
      </li>,
    );
  } else {
    if (shippingCost[0].percentage > 0) {
      shippingCostTerms.push(
        <li key="shippingCostPercentage"> Shipping cost: {shippingCost[0].percentage}% per item</li>,
      );
    }
    if (shippingCost[0].fixed_per_unit > 0) {
      shippingCostTerms.push(
        <li key="shippingCostFixed"> Shipping cost: {shippingCost[0].fixed_per_unit / 100} per unit</li>,
      );
    }
  }
  return shippingCostTerms;
}
